export default __webpack_public_path__ + "images/height.svg";